import "./App.css";
import logo from "./assets/logo.png";
import { Routes, Route } from "react-router-dom";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <div className="gradient-background">
              <main className="main-content">
                <img src={logo} className="app-logo" alt="FoodFax Logo" />

                <div className="store-buttons">
                  <a
                    href="https://apps.apple.com/your-app-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="app-store-button"
                  >
                    <img
                      src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
                      alt="Download on the App Store"
                    />
                  </a>
                </div>
              </main>

              <footer className="footer">
                <div className="footer-links">
                  <a href="/privacy" className="footer-link">
                    Privacy Policy
                  </a>
                  <span className="footer-separator">|</span>
                  <a href="/terms" className="footer-link">
                    Terms of Service
                  </a>
                </div>
              </footer>
            </div>
          }
        />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </div>
  );
}

export default App;
